module.exports = __webpack_public_path__ + "static/img/181221-mthfr-nutrition.aa74716.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/181221-mthfr-nutrition.jpg
// module id = yNfq
// module chunks = 0